import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import backIcon from '../../assets/backspace-icon.png';
import './PioneerSummaryAnalytics.css';

function Metric({ label, value }) {
  return (
    <div className="psa-metric">
      <span>{label}</span>
      <strong>{Number(value || 0).toLocaleString()}</strong>
    </div>
  );
}

function Period({ title, data }) {
  if (!data) return null;

  return (
    <section className="psa-period">
      <h2>{title}</h2>

      <h3>Summary views</h3>
      <div className="psa-grid">
        <Metric label="Total opens" value={data.totalOpens} />
        <Metric label="Unique viewers" value={data.uniqueViewers} />
        <Metric
          label="Unique profiles viewed"
          value={data.uniqueProfilesViewed}
        />
        <Metric
          label="Own summary opens"
          value={data.ownSummaryOpens}
        />
        <Metric
          label="Other people's summaries"
          value={data.otherSummaryOpens}
        />
      </div>

      <h3>Where people opened it</h3>
      <div className="psa-grid">
        <Metric
          label="Home"
          value={data.opensByEntryPoint?.home}
        />
        <Metric
          label="Profile"
          value={data.opensByEntryPoint?.profile}
        />
        <Metric
          label="User profiles"
          value={data.opensByEntryPoint?.user_profile}
        />
        <Metric
          label="Other profiles viewed from Home"
          value={data.otherProfilesViewedFromHome}
        />
      </div>

      <h3>What people tapped</h3>
      <div className="psa-grid">
        <Metric
          label="Post highlights"
          value={data.highlightTapsByType?.post}
        />
        <Metric
          label="Badge highlights"
          value={data.highlightTapsByType?.badge}
        />
        <Metric label="Follow taps" value={data.followTaps} />
        <Metric label="Message taps" value={data.messageTaps} />
      </div>
    </section>
  );
}

export default function PioneerSummaryAnalytics() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await api.get(
        '/admin/pioneer-summary/overview'
      );
      setData(response.data);
    } catch (err) {
      setError(
        err?.response?.status === 403
          ? 'You do not have access to these metrics.'
          : 'Could not load Pioneer Summary analytics.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="psa-screen">
      <header className="psa-header">
        <button
          type="button"
          onClick={() => navigate('/admin')}
          aria-label="Back to admin dashboard"
        >
          <img src={backIcon} alt="" />
        </button>
        <h1>Pioneer Summary</h1>
        <button
          type="button"
          onClick={load}
          disabled={loading}
          className="psa-refresh"
        >
          Refresh
        </button>
      </header>

      <main className="psa-scroll">
        {loading && !data && (
          <p className="psa-state">Loading analytics…</p>
        )}

        {error && (
          <div className="psa-state">
            <p>{error}</p>
            <button type="button" onClick={load}>
              Try again
            </button>
          </div>
        )}

        {data && (
          <>
            <p className="psa-note">
              Opens count visible summaries. Follow and Message
              numbers count taps, not completed actions.
            </p>

            <Period title="Last 7 days" data={data.last7Days} />
            <Period title="Last 30 days" data={data.last30Days} />
          </>
        )}
      </main>
    </div>
  );
}
